import React from 'react';
import t from 'prop-types';

var SeccionSuperior = function SeccionSuperior(_ref) {
  var children = _ref.children;
  return React.createElement('div', {
    className: 'seccionSuperior'
  }, children);
};

SeccionSuperior.propTypes = process.env.NODE_ENV !== "production" ? {
  children: t.any
} : {};
export default SeccionSuperior;